import React from "react";
import PropTypes from "prop-types";
import ReactToggle from "react-toggle";
import { ReportDialogPropTypes } from "./ReportDialogProps";
const KEEP_ME_UPDATED = "keep_me_updated";

const FormDetails = ({
  onSubmit,
  onClose,
  user,
  ...options
}) => {
  const [formConfig, setFormConfig] = React.useState({
    invalid: false,
    displayErrors: false,
    submitError: false
  });
  const handleSubmit = React.useCallback(event => {
    event.preventDefault();

    if (!event.target.checkValidity()) {
      // form is invalid! so we do nothing
      return setFormConfig({
        invalid: true,
        displayErrors: true
      });
    }

    const fields = Array.prototype.slice.call(event.target).filter(el => el.name).reduce((form, el) => ({ ...form,
      [el.name]: el.name === KEEP_ME_UPDATED ? el.value === "on" : el.value
    }), {});
    onSubmit(fields);
  }, [setFormConfig, onSubmit]);
  const name = user ? user.name : "";
  const email = user ? user.email : "";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("h2", null, options.title), /*#__PURE__*/React.createElement("p", null, `${options.subtitle} ${options.subtitle2}`)), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, formConfig.invalid && formConfig.displayErrors && /*#__PURE__*/React.createElement("div", {
    className: "error-wrapper"
  }, /*#__PURE__*/React.createElement("p", {
    className: "message-error"
  }, options.errorFormEntry)), /*#__PURE__*/React.createElement("div", {
    className: "form-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-field clearfix"
  }, /*#__PURE__*/React.createElement("label", null, options.labelName), /*#__PURE__*/React.createElement("input", {
    className: "form-input",
    type: "text",
    name: "name",
    required: true,
    id: "id_name",
    maxLength: 128,
    defaultValue: name
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-field clearfix"
  }, /*#__PURE__*/React.createElement("label", null, options.labelEmail), /*#__PURE__*/React.createElement("input", {
    className: "form-input",
    type: "email",
    name: "email",
    required: true,
    id: "id_email",
    maxLength: 75,
    defaultValue: email
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-field clearfix"
  }, /*#__PURE__*/React.createElement("label", null, options.labelComments), /*#__PURE__*/React.createElement("textarea", {
    className: "form-input",
    name: "comments",
    id: "id_comments",
    rows: "10",
    cols: "40",
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-field clearfix"
  }, /*#__PURE__*/React.createElement("label", null, options.labelKeepMeUpdated, "  ", /*#__PURE__*/React.createElement(ReactToggle, {
    icons: false,
    name: KEEP_ME_UPDATED
  })))), /*#__PURE__*/React.createElement("div", {
    className: "form-submit clearfix"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn"
  }, options.labelSubmit), /*#__PURE__*/React.createElement("a", {
    className: "close",
    onClick: onClose
  }, options.labelClose), /*#__PURE__*/React.createElement("p", {
    className: "powered-by"
  }, "Crash reports powered by ", /*#__PURE__*/React.createElement("a", {
    href: "https://sentry.io"
  }, "Sentry")))));
};

FormDetails.defaultProps = {
  user: {
    name: "",
    email: ""
  }
};
FormDetails.propTypes = { ...ReportDialogPropTypes,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};
export default FormDetails;